const normalizeWhitespace = (value) =>
  String(value ?? "").replace(/\s+/g, " ").trim();

const RETAIL_SECTOR_ALIASES = {
  apparel: "Apparel",
  "appliances/electronics": "Appliances/Electronics",
  automotive: "Automotive",
  "banquet halls/event venues": "Banquet Halls/Event Venues",
  "bars/gaming/nightlife concepts": "Bars/Gaming/Nightlife Concepts",
  beauty: "Beauty",
  "body piercing/tattoo parlor/tattoo removal":
    "Body Piercing/Tattoo Parlor/Tattoo Removal",
  "c-stores/gas stations": "C-Stores/Gas Stations",
  "cards/gifts/novelty/stationary": "Cards/Gifts/Novelty/Stationary",
  "coworking/office space": "Coworking/Office Space",
  "crafts/games/hobbies/toys": "Crafts/Games/Hobbies/Toys",
  "diy/hardware/home improvement": "DIY/Hardware/Home Improvement",
  "discounters/superstores/warehouse stores":
    "Discounters/Superstores/Warehouse Stores",
  "drug stores/pharmacies": "Drug Stores/Pharmacies",
  "dry cleaning/laundry/tailoring": "Dry Cleaning/Laundry/Tailoring",
  "educational concepts": "Educational Concepts",
  "experiential retail": "Experiential Retail",
  "financial services": "Financial Services",
  "fitness equipment store": "Fitness Equipment Store",
  florists: "Florists",
  "food halls": "Food Halls",
  "food retail (alcohol/spirits)": "Food Retail (Alcohol/Spirits)",
  "food retail (specialty)": "Food Retail (Specialty)",
  "furniture/furnishings/lifestyle": "Furniture/Furnishings/Lifestyle",
  "garden/pool/yard": "Garden/Pool/Yard",
  grocery: "Grocery",
  "gyms/health clubs": "Gyms/Health Clubs",
  "holiday/party/seasonal": "Holiday/Party/Seasonal",
  jewelry: "Jewelry",
  "luggage/travel stores": "Luggage/Travel Stores",
  "mail/shipping stores": "Mail/Shipping Stores",
  "medical/wellness": "Medical/Wellness",
  "media stores": "Media Stores",
  "miscellaneous retail": "Miscellaneous Retail",
  "music store": "Music Store",
  "nutrition/supplements/vitamins": "Nutrition/Supplements/Vitamins",
  "office supplies": "Office Supplies",
  "optical retail/optometry": "Optical Retail/Optometry",
  "pet related": "Pet Related",
  "print/sign shops": "Print/Sign Shops",
  restaurants: "Restaurants",
  "social club": "Social Club",
  "social crafting concepts": "Social Crafting Concepts",
  "sporting goods": "Sporting Goods",
  "sports collectibles/memorabilia": "Sports Collectibles/Memorabilia",
  "sports training": "Sports Training",
  theaters: "Theaters",
  "tobacconists/vape": "Tobacconists/Vape Shops",
  "tobacconists/vape shops": "Tobacconists/Vape Shops",
  "veterinary care": "Veterinary Care",
  "xxx adult oriented": "XXX Adult Oriented",
};

const RETAIL_SUBSECTOR_ALIASES = {
  accessories: "Accessories",
  "aesthetics/medispa": "Aesthetics/MediSpa",
  "ar/ir/vr/esports": "AR/IR/VR/eSports",
  "art auction house": "Art Auction House",
  "art/culture/exhibits/museums": "Art/Culture/Exhibits/Museums",
  "auditory/hearing aids": "Auditory/Hearing Aids",
  "baby/children's apparel": "Baby/Children's Apparel",
  "ballet/dance school/studio": "Ballet/Dance School/Studio",
  "banks/credit unions": "Banks/Credit Unions",
  "bath/body/cosmetics/fragrance": "Bath/Body/Cosmetics/Fragrance",
  "behavioral/counseling/mental health":
    "Behavioral/Counseling/Mental Health",
  "beer halls/craft brewing taprooms": "Beer Halls/Craft Brewing Taprooms",
  books: "Books",
  "blood/plasma donation centers": "Blood/Plasma Donation Centers",
  "bridal/formalwear/maternity": "Bridal/Formalwear/Maternity",
  "butcher shop/meat store": "Butcher Shop/Meat Stores",
  "butcher shop/meat stores": "Butcher Shop/Meat Stores",
  "cannabis dispensary": "Cannabis Dispensary",
  "car dealerships (only those active in shopping center settings)":
    "Car Dealerships (only those active in shopping center settings)",
  "car wash": "Car Wash",
  "casinos/gaming (active in shopping center settings only)":
    "Casinos/Gaming (active in shopping center settings only)",
  "casual dining": "Casual Dining",
  "charcuterie concepts": "Charcuterie Concepts",
  chiropractic: "Chiropractic",
  "childcare/daycare/education": "Childcare/Daycare/Education",
  "cleaning services": "Cleaning Services",
  "comic book stores": "Comic Book Stores",
  "comedy clubs/performance stages": "Comedy Clubs/Performance Stages",
  "competitive socializing": "Competitive Socializing",
  "cooking schools": "Cooking Schools",
  "country & western bars": "Country & Western Bars",
  dental: "Dental",
  "department stores": "Department Stores",
  dermatology: "Dermatology",
  "dinner theaters": "Dinner Theaters",
  "driving school": "Driving Schools",
  "driving schools": "Driving Schools",
  "eco-friendly/recycling": "Eco-Friendly/Recycling",
  "escape rooms/rage rooms": "Escape Rooms/Rage Rooms",
  "equestrian/saddlery": "Equestrian/Saddlery",
  "ethnic grocery": "Ethnic Grocery",
  "family amusements": "Family Amusements",
  "family apparel": "Family Apparel",
  "fine dining": "Fine Dining",
  "farm/home/ranch": "Farm/Home/Ranch",
  "funeral home/mortuary": "Funeral Home/Mortuary",
  "grab and go/meal kit concepts": "Grab and Go/Meal Kit Concepts",
  "hair/nails/salon/spa": "Hair/Nails/Salon/Spa",
  "insurance offices": "Insurance Offices",
  "intimates/lingerie": "Intimates/Lingerie",
  karaoke: "Karaoke Bars",
  "karaoke bars": "Karaoke Bars",
  "laboratory/testing": "Laboratory/Testing",
  "language schools": "Language Schools",
  "liquor distillery/tasting rooms": "Liquor Distillery/Tasting Rooms",
  "live music venues": "Live Music Venues",
  "marine retail": "Marine Retail",
  "medical equipment/supplies": "Medical Equipment/Supplies",
  "men's apparel": "Men's Apparel",
  "men's health": "Men's Health",
  "military goods/surplus": "Military Goods/Surplus",
  "miscellaneous financial services": "Miscellaneous Financial Services",
  "miscellaneous medical": "Miscellaneous Medical",
  newsstand: "Newsstand",
  "off leash dog park/bar": "Off Leash Dog Park Bars",
  "off leash dog park bars": "Off Leash Dog Park Bars",
  "organic grocery": "Organic Grocery",
  "parts and/or services": "Parts and/or Services",
  "physical therapy": "Physical Therapy",
  pickleball: "Pickleball",
  "photo gallery": "Photo Gallery",
  qsr: "QSR",
  "record/video stores": "Record/Video Stores",
  "recording studio": "Recording Studio",
  "relocation/storage services": "Relocation/Storage Services",
  "retail incubator space/sublessor": "Retail Incubator Space/Sublessor",
  "recycling/renewables": "Recycling/Renewables",
  "senior care": "Senior Care",
  shoes: "Shoes",
  "shoe care/maintenance": "Shoe Care/Maintenance",
  "social club": "Social Club",
  "social clubs": "Social Club",
  "souvenir shops/locally themed retail":
    "Souvenir Shops/Locally Themed Retail",
  "staffing agencies": "Staffing Agencies",
  "strip clubs": "Strip Clubs",
  "swim schools": "Swim Schools",
  "tax preparation": "Tax Preparation",
  "trade/vocational school": "Trade/Vocational School",
  "traditional grocery": "Traditional Grocery",
  "travel agency": "Travel Agency",
  "trophy store": "Trophy Store",
  "uniforms/workwear": "Uniforms/Workwear",
  "urgent care": "Urgent Care",
  "weight loss": "Weight Loss",
  "wine bar/wine tasting": "Wine Bar/Wine Tasting",
  "women's apparel": "Women's Apparel",
};

const normalizeRetailCategory = (value, aliases) => {
  const cleaned = normalizeWhitespace(value);
  if (!cleaned) {
    return "";
  }

  return aliases[cleaned.toLowerCase()] || cleaned;
};

const normalizeRetailSector = (value) =>
  normalizeRetailCategory(value, RETAIL_SECTOR_ALIASES);

const normalizeRetailSubsector = (value) =>
  normalizeRetailCategory(value, RETAIL_SUBSECTOR_ALIASES);

export const normalizeRetailConceptRecord = (row = {}) => ({
  ...row,
  retail_sector: normalizeRetailSector(row?.retail_sector),
  retail_subsector: normalizeRetailSubsector(row?.retail_subsector),
});
